import {Widget} from "base/assets/js/widget/Widget.js";
import {DraftMenu} from "base/assets/js/widget/DraftMenu.js";

/**
 * автосохранение черновика
 */
export class DraftDropBtn extends Widget {

	iDraftId = null;

	run() {
		this._my( { 'draft-id': 'i:iDraftId' } );
		this._on( '', 'click', ( oEvent ) => {
			if( !confirm( 'Вы действительно хотите удалить черновик?' ) ) {
				return;
			}
			$.post( '/topic/draftDrop', { iDraftId: this.iDraftId }, () => {

				// по окончанию удаления, обновляем меню
				const oDraftMenu = this._rel()
					.typeOf( DraftMenu )
					.find();
				oDraftMenu.reload();
			} )
		} )
	}
}